export default __webpack_public_path__ + "static/media/EM1850.34I-42460_-25444_0.8f9706db.jpg";